itsoftApp.createModule("focusVisible", function () {
    /* Эмулирем на JS псевдокласс focus-visible, так как некоторые браузеры его не поддерживают */
    /* При клике с помощью мышки или пальца не будут срабатывать стили для :focus */
    itsoftApp.loadScript("assets/scripts/focus-visible/focus-visible.min.js");
});